/**
 *
 * app-runtime-config reducer
 *
 */
import { SET_ADOBE_TARGET } from './runtime-config-constants';
import _get from 'lodash/get';
export const initialState = {
    dataEndpoints: {},
};

const appRuntimeConfigReducer = (state = initialState, action) => {
    
        switch (action.type) {   
            case  SET_ADOBE_TARGET:
                let { type, data } = action;
                
                const mbox = _get(data, '[0].content[0]', {});
                const newState = {...state, ...{ mbox: mbox }};
                return newState
            default:
                return state;

        }
    
};

export default appRuntimeConfigReducer;